<div class="promo-code d-flex flex-column-reverse flex-md-row justify-content-between align-items-center w-100">
    <div class="flex-grow-1 d-flex align-items-center me-4">
        <form [formGroup]="promoCodeForm" class="d-flex flex-column w-100 me-4">
            <div class="d-flex flex-row flex-wrap flex-sm-nowrap align-items-center w-100">
                <div class="d-flex flex-grow-1 me-2 w-100 w-sm-auto">
                    <ng-select
                        id="promo-code-select"
                        class="promo"
                        [items]="promoCodesList"
                        bindLabel="name"
                        bindValue="name"
                        [addTag]="true"
                        placeholder="Select a promo code"
                        formControlName="promoCode"
                        appearance="outline"
                        appendTo="body"
                        (open)="onOpenDropDown()"
                        (close)="onCloseDropDown()"
                    >
                    </ng-select>
                </div>
                <div class="d-flex align-items-center flex-shrink-0">
                    @if (!isLoading && !promoCodeApplied) {
                        <button
                            id="apply-button"
                            mat-button
                            matSuffix
                            type="submit"
                            color="primary"
                            (click)="validatePromoCode(); $event.stopPropagation()"
                            [disabled]="isLoading"
                        >
                            Apply
                        </button>
                    }
                    @if (!isLoading && !!promoCodeApplied) {
                        <button
                            id="submit-button"
                            mat-button
                            matSuffix
                            type="submit"
                            color="error"
                            (click)="deletePromoCode(); $event.stopPropagation()"
                            [disabled]="isLoading"
                        >
                            Delete
                        </button>
                    }
                    @if (isLoading) {
                        <mat-spinner diameter="24" matSuffix class="me-3"></mat-spinner>
                    }
                </div>
            </div>
            <mat-error>
                @if (errorVisible) {
                    @for (message of messageConfig; track message) {
                        <span class="m-0 message-mat-error"> {{ message.message }} </span>
                    }
                }
            </mat-error>
        </form>
    </div>
</div>
